"use client";
import dynamic from "next/dynamic";
import { useState, useEffect } from "react";
const ExpandQuestion = dynamic(() => import("./component/expand"), { ssr: false });
import ColorStyleContext from "@/lib/providers/color-style-privider";
import { useContext } from "react";

const TopFaqsComponentClient = ({ faqs, loc, pathName }: { faqs: any; loc: string; pathName: string }) => {
    const [selectedFAQ, setSelectedFAQ] = useState(faqs.menuList[0]);
    const colorStyle = useContext(ColorStyleContext);

    return (
        <div className="flex flex-col sm:flex-row gap-10 min-h-96 px-4">
            <div className="flex flex-col sm:w-80 hide-padding2">
                {faqs.menuList?.map((faq: any, index: number) => (
                    <div
                        key={faq.id}
                        onClick={() => setSelectedFAQ(faq)}
                        className={`text-base text-wrap text-start 
                    whitespace-pre-line border-b py-6 sm:p-6 cursor-pointer hover:opacity-80
                    ${selectedFAQ.id === faq.id ? "font-bold" : "font-light"} dynamic-color`}
                        style={{
                            "--dynamic-color": colorStyle?.headingSub || "#2c568a",
                            "--dynamic-hover-color": colorStyle?.headingSub || "#2c568a",
                            "--dynamic-focus-color": colorStyle?.headingSub || "#2c568a",
                            } as React.CSSProperties}>
                        {faq.attributes.displayName}
                    </div>
                ))}
            </div>
            <div className="hidden sm:flex border"></div>
            <div className="flex flex-col w-full grow hide-padding dynamic-color">
                {selectedFAQ
                    ? selectedFAQ.faqItems.map((item: any) => <ExpandQuestion key={item.id} item={item} open={false} />)
                    : null}
            </div>
        </div>
    );
};

export default TopFaqsComponentClient;
